module.exports = __webpack_public_path__ + "img/overseas-service.a526962c.jpg";